import { render } from "./PlanejamentoInjecao.vue?vue&type=template&id=757aa2c8&scoped=true"
import script from "./PlanejamentoInjecao.vue?vue&type=script&lang=js"
export * from "./PlanejamentoInjecao.vue?vue&type=script&lang=js"

import "./PlanejamentoInjecao.vue?vue&type=style&index=0&id=757aa2c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-757aa2c8"]])

export default __exports__